<template>
    <LayoutSub>
        <SubSection class="pb-0">
            <div class="report_container">
                <div class="report_intro">
                    <h2>클린 신고센터</h2>
                    <p>클린 신고센터는 고객 및 임직원 모두가 공정하고 투명한 업무 환경을 조성할 수 있도록 운영되고 있는 신고 채널입니다.</p>
                    <p><strong>금품수수, 부정 청탁, 직장 내 괴롭힘, 성희롱 등 윤리·준법 위반 사항을 익명으로 신고할 수 있으며, 접수된 내용은 관련 절차에 따라 공정하게 조사·처리됩니다.</strong></p>
                    <p><strong>신고자와 제보 내용은 철저히 보호되며, 신고로 인한 불이익은 발생하지 않습니다.</strong></p>
                </div>

                <div class="report_section">
                    <h3>제보자 보호</h3>
                    <div class="info_box">
                        <p>제보자의 신상정보와 제보내용은 보호되며, 제보자 본인의 동의 없이 그 신분을 노출하거나 이를 암시하는 어떠한 정보도 공개하지 않습니다.</p>
                        <ul>
                            <li>제보 사실에 대해 익명으로 제보 가능합니다.</li>
                            <li>단, 익명 제보의 경우 내용이 구체적이지 않거나, 사실관계가 불분명할 경우 조사를 진행하지 않을 수 있습니다.</li>
                            <li>제보자에 대한 보복이나 불이익 제공 등의 제보자 보호 위반행위는 취업규칙 등 사내 규정에 따라 엄격히 처벌됩니다.</li>
                            <li>제보하기 코너는 안전한 보안체계로 보호되고 있으며, 제보조사 업무는 지정된 담당자에 의해 보안 유지 하에 처리됩니다.</li>
                        </ul>
                    </div>
                </div>

                <form novalidate ref="reportForm" @submit.prevent="submitReport" :aria-busy="submitLoading">
                    <fieldset :disabled="submitLoading">
                        <legend class="sr_only">제보 작성</legend>
                        <div class="report_section">
                            <h3>개인정보 수집·이용 동의</h3>
                            <p class="section_desc">한국정보통신㈜(이하 “회사”)는 클린 신고센터 운영을 위하여 「개인정보 보호법」 등 관계 법령에 따라 아래와 같이 개인정보를 수집·이용하고자 합니다. 내용을 충분히 확인하신 후 동의 여부를 결정하여 주시기 바랍니다.</p>
                            <div class="table_scroll" tabindex="0" role="region" aria-label="개인정보 수집 및 이용 안내" data-lenis-prevent>
                                <table>
                                    <caption class="sr_only">개인정보 수집·이용 안내</caption>
                                    <thead><tr><th scope="col">수집·이용 목적</th><th scope="col">수집·이용하는 개인정보 항목</th><th scope="col">보유·이용기간</th><th scope="col">동의 거부 권리 및 거부에 따른 불이익</th></tr></thead>
                                    <tbody><tr>
                                        <td>윤리제보 접수 및 처리<br />신고내용의 사실관계 확인 및 조사<br />신고 처리 결과 안내<br />신고사항에 따른 후속 조치 및 관련 기록 관리</td>
                                        <td>신고자 성명<br />휴대전화번호<br />이메일 주소<br />신고내용(상담유형, 발생 경위, 증빙자료 및 신고 내용에 포함된 개인정보 등)</td>
                                        <td>회사는 관계 법령에 따라 개인정보를 보존하여야 하는 경우를 제외하고, 신고 처리 완료일로부터 3년간 개인정보를 보유 및 이용합니다.</td>
                                        <td>개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 다만, 필수항목에 대한 수집·이용에 동의하지 않는 경우에도 익명으로 신고할 수 있으나, 신고내용에 대한 사실 확인이 어려운 경우에는 조사 또는 처리에 제한이 있을 수 있으며, 신고 접수 확인 및 처리 결과 안내가 제공되지 않을 수 있습니다.</td>
                                    </tr></tbody>
                                </table>
                            </div>
                            <div class="consent_row">
                                <p>개인정보 수집·이용에 대한 동의 여부 <span class="ess">*</span></p>
                                <div class="choice_group">
                                    <label><input ref="personalYn" v-model="personalYn" type="radio" name="reportConsent" value="Y" /> 동의</label>
                                    <label><input v-model="personalYn" type="radio" name="reportConsent" value="N" /> 미동의</label>
                                </div>
                            </div>
                        </div>

                        <div class="report_section">
                            <h3>제보 유형</h3>
                            <div class="info_box type_list">
                                <div v-for="(type, index) in reportTypes" :key="type.code">
                                    <h4>{{ index + 1 }}. {{ type.name }}</h4>
                                    <p>{{ type.description }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="report_section">
                            <p class="required_note"><span class="ess">*</span> 항목은 필수 항목입니다. 성명과 연락처를 입력하지 않아도 제보할 수 있습니다.</p>
                            <div class="form_fields">
                                <div class="form_row full">
                                    <fieldset class="type_fieldset">
                                        <legend>제보 유형 <span class="ess">*</span> <span class="hint">(복수 선택 가능)</span></legend>
                                        <div class="choice_group">
                                            <label v-for="type in reportTypes" :key="type.code">
                                                <input v-model="report.reportTypeCodes" type="checkbox" name="reportType" :value="type.code" /> {{ type.name }}
                                            </label>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="form_row full">
                                    <label for="reportSubject">제목 <span class="ess">*</span></label>
                                    <input id="reportSubject" ref="subject" v-model="report.subject" type="text" maxlength="300" required placeholder="제목을 입력해 주세요." />
                                </div>
                                <div class="form_row">
                                    <label for="reportName">성명</label>
                                    <input id="reportName" v-model="report.name" type="text" maxlength="100" autocomplete="name" placeholder="성명을 입력해 주세요." />
                                </div>
                                <div class="form_row">
                                    <label for="reportEmail">이메일</label>
                                    <div class="email_row">
                                        <input id="reportEmail" ref="email" v-model="emailLocal" type="text" maxlength="200" aria-label="이메일 아이디" placeholder="이메일 아이디" />
                                        <span>@</span>
                                        <input v-model="emailDomain" type="text" maxlength="200" aria-label="이메일 도메인" @input="emailDomainSelection = ''" />
                                        <select v-model="emailDomainSelection" aria-label="이메일 도메인 선택" @change="emailDomain = emailDomainSelection">
                                            <option value="">직접입력</option>
                                            <option v-for="domain in emailDomains" :key="domain" :value="domain">{{ domain }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form_row">
                                    <label for="reportTel">전화번호</label>
                                    <input id="reportTel" ref="telNo" v-model="report.telNo" type="tel" autocomplete="tel" placeholder="전화번호를 입력해 주세요." />
                                </div>
                                <div class="form_row">
                                    <label for="reportHp">휴대전화번호</label>
                                    <input id="reportHp" ref="hpNo" v-model="report.hpNo" type="tel" placeholder="휴대전화번호를 입력해 주세요." />
                                </div>
                                <div class="form_row full">
                                    <label for="reportContents">내용 <span class="ess">*</span></label>
                                    <textarea id="reportContents" ref="contents" v-model="report.contents" required placeholder="발생 경위 등 제보 내용을 구체적으로 입력해 주세요." data-lenis-prevent></textarea>
                                </div>
                                <div v-for="(file, index) in files" :key="index" class="form_row file_row">
                                    <label :for="`reportFile${index}`">첨부파일 #{{ index + 1 }}</label>
                                    <div class="file_control">
                                        <input :id="`reportFile${index}`" type="file" @change="selectFile($event, index)" />
                                        <button v-if="file" type="button" :aria-label="`첨부파일 ${index + 1} 삭제`" @click="removeFile(index)">삭제</button>
                                    </div>
                                </div>
                            </div>
                            <div class="submit_wrap">
                                <button type="submit" :disabled="submitLoading">{{ submitLoading ? '접수 중...' : '제보하기' }}</button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </SubSection>
    </LayoutSub>
</template>

<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import { postReport } from '@/api';

const emptyReport = () => ({ reportTypeCodes: [], subject: '', name: '', telNo: '', hpNo: '', contents: '' });

export default {
    components: { LayoutSub, SubSection },
    data() {
        return {
            report: emptyReport(),
            personalYn: '',
            emailLocal: '',
            emailDomain: '',
            emailDomainSelection: '',
            emailDomains: ['naver.com', 'daum.net', 'hanmail.net', 'nate.com', 'hotmail.com', 'gmail.com', 'icloud.com'],
            files: [null, null, null],
            submitLoading: false,
            reportTypes: [
                { code: 'ETHICS_COMPLIANCE', name: '윤리·준법', description: '금품·향응 수수, 협력사 관련 부정행위, 이해상충, 문서·계수 조작 등 회사의 윤리규정이나 법규를 위반한 행위에 대한 신고입니다.' },
                { code: 'HUMAN_RIGHTS_LABOR', name: '인권·노동', description: '직장 내 괴롭힘, 폭언·폭행, 차별, 성희롱, 부당한 요구 및 대우 등 임직원의 인권과 노동 환경에 관한 고충을 신고하는 항목입니다.' },
                { code: 'SAFETY_ENVIRONMENT', name: '안전·환경', description: '산업안전보건 관련 위반, 안전수칙 미준수, 위험요인 방치, 환경오염, 폐기물 및 유해 물질 관리 등 안전·환경과 관련된 사항을 신고하는 항목입니다.' },
                { code: 'ASSET_INFORMATION_OTHER', name: '자산·정보 및 기타', description: '회사 자산의 부당한 사용, 회사의 중요정보 및 영업 비밀 유출, 개인정보 관련 위반 등과 함께 위 항목에 해당하지 않는 기타 고충을 신고하는 항목입니다.' },
            ],
        };
    },
    methods: {
        selectFile(event, index) {
            this.files[index] = event.target.files[0] || null;
        },
        removeFile(index) {
            this.files[index] = null;
            this.$refs.reportForm.querySelector(`#reportFile${index}`).value = '';
        },
        invalid(message, field) {
            alert(message);
            field?.focus();
            return false;
        },
        async submitReport() {
            if (this.submitLoading) return;
            if (!['Y', 'N'].includes(this.personalYn)) return this.invalid('개인정보 수집·이용에 대한 동의 여부를 선택해 주세요.', this.$refs.personalYn);
            if (!this.report.reportTypeCodes.length) return this.invalid('제보 유형을 1개 이상 선택해 주세요.', this.$refs.reportForm.querySelector('[name="reportType"]'));
            const payload = { reportTypeCodes: [...this.report.reportTypeCodes], personalYn: this.personalYn };
            for (const field of ['subject', 'contents']) {
                payload[field] = this.report[field].trim();
                if (!payload[field]) return this.invalid(field === 'subject' ? '제목을 입력해 주세요.' : '내용을 입력해 주세요.', this.$refs[field]);
            }
            if (payload.subject.length > 300) return this.invalid('제목은 300자 이내로 입력해 주세요.', this.$refs.subject);
            const name = this.report.name.trim();
            if (name.length > 100) return this.invalid('성명은 100자 이내로 입력해 주세요.', this.$refs.reportForm.querySelector('#reportName'));
            if (name) payload.name = name;
            const local = this.emailLocal.trim();
            const domain = this.emailDomain.trim();
            if (local || domain) {
                const email = `${local}@${domain}`;
                if (email.length > 200 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.invalid('올바른 이메일 주소를 200자 이내로 입력해 주세요.', this.$refs.email);
                payload.email = email;
            }
            for (const field of ['telNo', 'hpNo']) {
                const phone = this.report[field].trim();
                if (!phone) continue;
                const digits = phone.replace(/-/g, '');
                const valid = /^[\d-]+$/.test(phone) && (field === 'hpNo' ? /^01[016789]\d{7,8}$/ : /^0\d{8,10}$/).test(digits);
                if (!valid) return this.invalid(field === 'hpNo' ? '올바른 휴대전화번호를 입력해 주세요.' : '올바른 전화번호를 입력해 주세요.', this.$refs[field]);
                payload[field] = digits;
            }
            this.submitLoading = true;
            const fallbackMessage = '제보가 접수되지 않았습니다. 입력 내용은 유지되며, 잠시 후 다시 시도해 주세요.';
            try {
                const result = await postReport(payload, this.files.filter(Boolean));
                if (result?.status && result.status !== 'success') {
                    this.invalid(typeof result.message === 'string' && result.message.trim() ? result.message : fallbackMessage);
                    return;
                }
                this.report = emptyReport();
                this.personalYn = '';
                this.emailLocal = '';
                this.emailDomain = '';
                this.emailDomainSelection = '';
                this.files = [null, null, null];
                this.$refs.reportForm.querySelectorAll('input[type="file"]').forEach((input) => { input.value = ''; });
                alert(result?.message || '제보가 정상적으로 접수되었습니다.');
            } catch (error) {
                const message = error.response?.data?.message;
                this.invalid(typeof message === 'string' && message.trim() ? message : fallbackMessage);
            } finally {
                this.submitLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped src="@/styles/cs/report.scss"></style>
